import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    padding: 0 16px;
  `,
  track: ({ theme }) => css`
    position: relative;
    width: 100%;
    height: 4px;
    background-color: ${theme.colors.neutral.variant[20]};
    border-radius: 40px;
    overflow: hidden;
  `,
  fill: css`
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 40px;
    transition: width 0.4s ease;
  `,
  fillFuchsia: ({ theme }) => css`
    background-color: ${theme.colors.primary.fuchsia[50]};
  `,
  fillEmerald: ({ theme }) => css`
    background-color: ${theme.colors.secondary.emerald[50]};
  `,
  labelRow: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  statusGroup: css`
    display: flex;
    align-items: center;
    gap: 4px;
  `,
  rightGroup: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  failedBadge: css`
    display: flex;
    align-items: center;
    gap: 4px;
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
